var _rect, _circle, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagPkr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#5754E5",
    strokeOpacity: 0.15
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15689_296765",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 34,
    height: 34
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 35C27.3888 35 35 27.3888 35 18C35 8.61116 27.3888 1 18 1C8.61116 1 1 8.61116 1 18C1 27.3888 8.61116 35 18 35Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15689_296765)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15689_296765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46 1H-5V35H46V1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 0H8V36H46V0Z",
    fill: "#01411C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6992 26C29.3936 26 33.1992 22.1944 33.1992 17.5C33.1992 12.8056 29.3936 9 24.6992 9C20.0048 9 16.1992 12.8056 16.1992 17.5C16.1992 22.1944 20.0048 26 24.6992 26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7095 21.338C34.8329 18.5616 35.1143 13.7789 32.3379 10.6555C29.5615 7.53212 24.7788 7.25079 21.6554 10.0271C18.532 12.8035 18.2507 17.5862 21.027 20.7096C23.8034 23.833 28.5861 24.1144 31.7095 21.338Z",
    fill: "#01411C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.581 11.3811L31.0581 15.2928L25.9458 14.172L30.7405 12.0739L28.0947 16.5896L27.581 11.3811Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15689_296765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 34,
    fill: "white",
    transform: "translate(-5 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagPkr);
export default __webpack_public_path__ + "static/media/flagPKR.5b794b71a188a9979aae81a90f1f52cc.svg";
export { ForwardRef as ReactComponent };